import { ImpairmentCategory, AssessmentResult, AccountStatus, Gender, LevelOfRunning, RunningExperience, ClientStatus, VideoType, WorkoutItemType, WorkoutType, CardioIntensityType, CardioType, CardioDistanceUOM, UserRole, MovementCategory, ExerciseEquipment, CategoryScore, AssessmentResultShort, RRAssessmentResultShort, AssessmentStatus, AssessmentAiStatus, AssessmentType, GaitScoreDescription, GaitProgramPrimaryFactor, PainType, TwoDimensionalAssessmentResult, ClientDayEventType, DayOfWeekFlag, RecurringEventFrequency, WorkoutCategory, AFHealthRiskCategory, AFCompositeScoreCategory, AFFitnessAssessmentCardioExerciseType, AFFitnessAssessmentMuscular1ExerciseType, AFFitnessAssessmentMuscular2ExerciseType, OrganizationType, NotificationType, TrainingLoadPeriodType, VDOTPaceType, RaceDistanceType, CurrentMessageMode, ActivityType, CalendarType, CalendarContextMenuOptions, TeamUserRole, SurveyQuestionType, ProgramCategory, MarketplaceStatus, MarketplaceCategoryDisplayType, AthleteType, GlobalMarketplaceExperienceLevel, GlobalMarketplaceProgramType, GarminPoolLengthUnit, WorkoutItemGarminRepeatType, GarminWorkoutStepIntensity, GarminWorkoutStepDurationType, GarminWorkoutStepDurationValueType, GarminWorkoutStepTargetType, GarminWorkoutStepTargetValueType, GarminWorkoutStepStrokeType, GarminWorkoutStepEquipmentType, MeasurementSystem, ExerciseResistanceType, GaitCapabilityCategory, WeightUOM, JournalType, ComparisonDirectionEnum, ComparisonResultEnum, WalkingCategory, RunDnaProduct, FootStrikePattern, RunningAnalysisReportScoreDescription, SpeedUnit, DistanceUnit, RunningDirection, RunningCue, TwoDimensionalProfileType, YearsOfExperience, RunnerSlowdownFactor, RunnerMotivation, TargetRaceType, RunningFormApproach, InjurySite, InjurySide, GenderPublic, InjuryImpact, InjuryImpactPast, InjuryAgo, MovementCapability, RunningAnalysisProgramPrimaryFactor } from './generatedModels';

export class Enums {
  public static ImpairmentCategoryEnum = new Map<number, string>([
    [ImpairmentCategory.Uncategorized, 'NA'],
    [ImpairmentCategory.OverstriderCadence, 'Overstrider Cadence'],
    [ImpairmentCategory.OverstriderKneeDrive, 'Overstrider Knee Drive'],
    [ImpairmentCategory.OverstriderCollapsing, 'Overstrider Collapsing'],
    [ImpairmentCategory.OverstriderGluteAmnesiac, 'Overstrider Glute Amnesiac'],
    [ImpairmentCategory.OverstriderGeneral, 'Overstrider'],
    [ImpairmentCategory.GeneralCadence, 'Cadence'],
    [ImpairmentCategory.CollapserCPD, 'Collapser CPD'],
    [ImpairmentCategory.CollapserBouncer, 'Collapser Bouncer'],
    [ImpairmentCategory.CollapserHip, 'Collapser Hip'],
    [ImpairmentCategory.Bouncer, 'Bouncer'],
    [ImpairmentCategory.GluteAmnesiac, 'Glute Amnesiac'],
    [ImpairmentCategory.Weaver, 'Weaver'],
    [ImpairmentCategory.Collapser, 'Collapser'],
    [ImpairmentCategory.OverstriderBouncer, 'Overstrider Bouncer'],
    [ImpairmentCategory.CadenceBouncer, 'Cadence Bouncer'],
    [ImpairmentCategory.CollapserGluteAmnesiac, 'Collapser Glute Amnesiac'],
    [ImpairmentCategory.PerformanceOptimization, 'Performance Optimization'],
  ]);

  public static AssessmentResultEnum = new Map<number, string>([
    [AssessmentResult.Able, 'Able'],
    [AssessmentResult.Unable, 'Unable'],
    [AssessmentResult.AbleWithPain, 'Able With Pain'],
    [AssessmentResult.UnableWithPain, 'Unable With Pain'],
    [AssessmentResult.ActiveLimitation, 'Active Limitation'],
    [AssessmentResult.PassiveLimitation, 'Passive Limitation'],
    [AssessmentResult.ActiveLimitationWithPain, 'Active Limitation With Pain'],
    [AssessmentResult.PassiveLimitationWithPain, 'Passive Limitation With Pain'],
  ]);

  public static AccountStatusEnum = new Map<number, string>([
    [AccountStatus.FullAccount, 'FullAccount'],
    [AccountStatus.PendingSetup, 'PendingSetup'],
  ]);

  public static GenderEnum = new Map<number, string>([
    [Gender.Other, 'Other'],
    [Gender.Male, 'Male'],
    [Gender.Female, 'Female'],
  ]);

  public static LevelOfRunningEnum = new Map<number, string>([
    [LevelOfRunning.Recreational, 'Recreational'],
    [LevelOfRunning.HighSchool, 'HighSchool'],
    [LevelOfRunning.College, 'College'],
    [LevelOfRunning.Professional, 'Professional'],
  ]);

  public static RunningExperienceEnum = new Map<number, string>([
    [RunningExperience.Beginner, 'Beginner'],
    [RunningExperience.OneToTwo, '1-2 Years'],
    [RunningExperience.ThreeToFive, 'ThreeToFive'],
    [RunningExperience.FiveToSeven, 'FiveToSeven'],
    [RunningExperience.SevenToTen, 'SevenToTen'],
    [RunningExperience.TenPlus, 'TenPlus'],
  ]);

  public static ClientStatusEnum = new Map<number, string>([
    [ClientStatus.Active, 'Active'],
    [ClientStatus.InActive, 'InActive'],
    [ClientStatus.Invited, 'Invited'],
  ]);

  public static VideoTypeEnum = new Map<number, string>([
    [VideoType.None, 'None'],
    [VideoType.Upload, 'Upload'],
    [VideoType.Public, 'Public'],
  ]);

  public static WorkoutItemTypeEnum = new Map<number, string>([
    [WorkoutItemType.Exercise, 'Exercise'],
    [WorkoutItemType.Circuit, 'Circuit'],
    [WorkoutItemType.Cardio, 'Cardio'],
    [WorkoutItemType.Interval, 'Interval'],
    [WorkoutItemType.GarminWorkoutStep, 'Step'],
    [WorkoutItemType.GarminWorkoutRepeatStep, 'Interval'],
  ]);

  public static WorkoutTypeEnum = new Map<number, string>([
    [WorkoutType.Strength, 'Strength'],
    [WorkoutType.Cardio, 'Cardio'],
    [WorkoutType.GarminRunning, 'Garmin Running'],
    [WorkoutType.GarminCycling, 'Garmin Cycling'],
    [WorkoutType.GarminLap_Swimming, 'Garmin Swimming'],
  ]);

  public static CardioIntensityTypeEnum = new Map<number, string>([
    [CardioIntensityType.HeartRateZone, 'Heart Rate Zone'],
    [CardioIntensityType.Pace, 'Pace'],
    [CardioIntensityType.RateOfPerceivedExertion, 'Rate of Perceived Exertion'],
    [CardioIntensityType.VDOTPace, 'VDOT Pace'],
  ]);

  public static CardioTypeEnum = new Map<number, string>([
    [CardioType.Work, 'Work'],
    [CardioType.Recovery, 'Recovery'],
  ]);

  public static CardioDistanceUOMEnum = new Map<number, string>([
    [CardioDistanceUOM.Miles, 'miles'],
    [CardioDistanceUOM.Kilometers, 'km'],
    [CardioDistanceUOM.Meters, 'meters'],
  ]);

  public static UserRoleEnum = new Map<number, string>([
    [UserRole.Runner, 'Athlete'],
    [UserRole.AssistantCoach, 'Assistant Coach'],
    [UserRole.HeadCoach, 'Head Coach'],
    [UserRole.GlobalCoach, 'Global Coach'],
    [UserRole.Administrator, 'Administrator'],
  ]);

  public static MovementCategoryEnum = new Map<number, string>([
    [MovementCategory.Uncategorized, 'Uncategorized'],
    [MovementCategory.SquatDorsiflexion, 'Squat: Dorsiflexion'],
    [MovementCategory.BackBend, 'Back Bend'],
    [MovementCategory.ToeTouchPosteriorChain, 'Toe Touch - Posterior Chain'],
    [MovementCategory.ToeTouchSpine, 'Toe Touch Spine'],
    [MovementCategory.SquatHipMobility, 'Squat: Hip Mobility'],
    [MovementCategory.UHBE, 'UHBE'],
    [MovementCategory.SingleLegSitToStand, 'Single Leg Sit to Stand'],
    [MovementCategory.BalanceHipCore, 'Balance: Hip/Core'],
    [MovementCategory.BalanceFootAnkle, 'Balance: Foot/Ankle'],
    [MovementCategory.CalfRaises, 'Calf Raises'],
    [MovementCategory.StrongFoot, 'Strong Foot'],
    [MovementCategory.RotationUE, 'Rotation: UE'],
    [MovementCategory.RotationLE, 'Rotation: LE'],
    [MovementCategory.SidePlank, 'Side Plank'],
  ]);

  public static ExerciseEquipmentEnum = new Map<number, string>([
    [ExerciseEquipment.AerobicPlyoStep, 'Aerobic / Plyo Step'],
    [ExerciseEquipment.Barbell, 'Barbell'],
    [ExerciseEquipment.Box, 'Box'],
    [ExerciseEquipment.Dumbbell, 'Dumbbell'],
    [ExerciseEquipment.FoamRoller, 'Foam Roller'],
    [ExerciseEquipment.HeavyBands, 'Heavy Bands'],
    [ExerciseEquipment.Kettlebell, 'Kettlebell'],
    [ExerciseEquipment.LacrosseBall, 'Lacrosse Ball'],
    [ExerciseEquipment.LargePhysioBall, 'Large Physio Ball'],
    [ExerciseEquipment.LoopBands, 'Loop Bands'],
    [ExerciseEquipment.MedicineBall, 'Medicine Ball'],
    [ExerciseEquipment.PullUpBar, 'Pull Up Bar'],
    [ExerciseEquipment.TRXSuspensionStraps, 'TRX / Suspension Straps'],
    [ExerciseEquipment.WeightedVest, 'Weighted Vest'],
    [ExerciseEquipment.YogaBlock, 'Yoga Block'],
  ]);

  public static CategoryScoreEnum = new Map<number, string>([
    [CategoryScore.U, 'U'],
    [CategoryScore.G, 'G'],
    [CategoryScore.GF, 'GF'],
    [CategoryScore.FG, 'FG'],
    [CategoryScore.F, 'F'],
    [CategoryScore.FP, 'FP'],
    [CategoryScore.PF, 'PF'],
    [CategoryScore.P, 'P'],
  ]);

  public static AssessmentResultShortEnum = new Map<number, string>([
    [AssessmentResultShort.Able, 'A'],
    [AssessmentResultShort.Unable, 'U'],
  ]);

  public static RRAssessmentResultShortEnum = new Map<number, string>([
    [RRAssessmentResultShort.Able, 'A'],
    [RRAssessmentResultShort.Unable, 'U'],
    [RRAssessmentResultShort.AblePain, 'AP'],
    [RRAssessmentResultShort.UnablePain, 'UP'],
  ]);

  public static AssessmentStatusEnum = new Map<number, string>([
    [AssessmentStatus.InProgress, 'Incomplete'],
    [AssessmentStatus.Completed, 'Programs Unassigned'],
    [AssessmentStatus.ProgramsAssigned, 'Programs Assigned'],
  ]);

  public static AssessmentAiStatusEnum = new Map<number, string>([
    [AssessmentAiStatus.InProgress, 'Processing'],
    [AssessmentAiStatus.VideosScheduledToProcess, 'Videos analyzing'],
    [AssessmentAiStatus.VideosProcessed, 'Finalizing'],
    [AssessmentAiStatus.Completed, 'Completed'],
    [AssessmentAiStatus.Failed, 'Failed'],
  ]);

  public static AssessmentTypeEnum = new Map<number, string>([
    [AssessmentType.GaitAnalysis, '3D Gait Analysis'],
    [AssessmentType.RRA, 'Runner Readiness Assessment'],
    [AssessmentType.LoadingLevels, 'Loading Levels Assessment'],
    [AssessmentType.TwoDimensional, '2D Assessment'],
    [AssessmentType.USAFFitnessAssessment, 'USAF Fitness Assessment'],
    [AssessmentType.GaitReport, 'Gait Report'],
    [AssessmentType.GaitCapability, 'Gait Capacity'],
    [AssessmentType.RunningAnalysisReport, 'Running Analysis Report'],
    [AssessmentType.TwoDimensionalAi, '2D AI Assessment'],
  ]);

  public static GaitScoreDescriptionEnum = new Map<number, string>([
    [GaitScoreDescription.Green, 'Nice job! Your walking is within normal ranges based on over 65 data points. Areas below in yellow or red may indicate areas to address to avoid future injury risk.'],
    [GaitScoreDescription.Yellow, 'Your total walking score is in the Yellow category, indicating minimal to moderate walking deficits. Individual scores in yellow or red indicate areas that may contribute to past, current, or future injuries and should be addressed.'],
    [GaitScoreDescription.Orange, 'Your total walking score is in the Orange category, indicating moderate walking deficits. Individual scores in yellow or red indicate areas that may contribute to past, current, or future injuries and should be addressed.'],
    [GaitScoreDescription.Red, 'Your total walking score is in the Red category, indicating significant walking deficits. Individual scores in yellow or red indicate areas that may contribute to past, current, or future injuries and should be addressed.'],
  ]);

  public static GaitProgramPrimaryFactorEnum = new Map<number, string>([
    [GaitProgramPrimaryFactor.Cadence, 'The largest contributor to your walking score is the rate of how many steps per minute you take, or your cadence . Too fast or slow of a cadence can impact your efficiency and stability of walking. Exercises, drills, or cues may help improve your walking form'],
    [GaitProgramPrimaryFactor.StrideLength, 'The largest contributor to your walking score is the distance between steps, or your stride length . Too short or too long of a stride length can impact your efficiency and stability of walking. Exercises, drills, or cues may help improve your walking form'],
    [GaitProgramPrimaryFactor.DoubleSupport, 'The largest contributor to your walking score is the time with both feet on the ground, or your double support . Too short or too long of a double support can impact your efficiency and stability of walking. Exercises, drills, or cues may help improve your walking form.'],
    [GaitProgramPrimaryFactor.DutyFactor, 'The largest contributor to your walking score is the time spent with your foot on the ground versus in the air, or your stride length. Too high or too low of a duty factor can impact your efficiency and stability of walking. Exercises, drills, or cues may help improve your walking form.'],
    [GaitProgramPrimaryFactor.StepWidth, 'The largest contributor to your walking score is how wide apart your feet are from the midline, or your step width. Too short or too long of a stride length can impact your efficiency and stability of walking. Exercises, drills, or cues may help improve your walking form.'],
    [GaitProgramPrimaryFactor.StanceTime, 'The largest contributor to your walking score is how long your feet are on the ground while walking, or your stance time. Too short or too long of a stance time can impact your efficiency and stability of walking. Exercises, drills, or cues may help improve your walking form.'],
    [GaitProgramPrimaryFactor.HipFlexionIc, 'The largest contributor to your walking score is the position of your hip when your foot hits the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues may help improve your walking form.'],
    [GaitProgramPrimaryFactor.KneeFlexionIc, 'The largest contributor to your walking score is the position of your knee when your foot hits the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues may help improve your walking form.'],
    [GaitProgramPrimaryFactor.AnkleFlexionIc, 'The largest contributor to your walking score is the position of your ankle when your foot hits the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PelvicRotationIc, 'The largest contributor to your walking score is the position of your pelvis when your foot hits the ground. Too high or too low of a rotation can impact how your body maintains stability. Exercises, drills, or cues for hip and lower back mobility/strength may help improve your walking form.'],
    [GaitProgramPrimaryFactor.TrunkRotationIc, 'The largest contributor to your walking score is the position of your trunk when your foot hits the ground. Too high or too low of a rotation can impact how your body maintains stability. Exercises, drills, or cues for hip and trunk mobility/strength may help improve your walking form.'],
    [GaitProgramPrimaryFactor.KneeFlexionMs, 'The largest contributor to your walking score is the position of your knee while your foot is on the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your knee may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PeakHipAdd, 'The largest contributor to your walking score is the adduction of your hip while your foot is on the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your hip may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PeakHipIr, 'The largest contributor to your walking score is the rotation of your hip while your foot is on the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your hip may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PeakAnklePronation, 'The largest contributor to your walking score is the movement of your foot/ankle into pronation while your foot is on the ground. Too high or too low pronation can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your foot/ankle may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PelvicDropMS, 'The largest contributor to your walking score is the amount your pelvis drops while your foot is on the ground. High amounts of pelvic drop may indicate hip weakness that can impact how your body maintains stability. Exercises, drills, or cues for hip mobility/strength may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PelvicTiltTo, 'The largest contributor to your walking score is the amount of tilt your pelvis goes through while your foot is on the ground. High amounts of pelvic drop may indicate hip weakness that can impact how your body maintains stability. Exercises, drills, or cues for hip mobility/strength may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PeakFootEr, 'The largest contributor to your walking score is the movement of your rotation your foot/ankle goes into while your foot is on the ground. External or Internal rotation of the foot can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your foot/ankle may help improve your walking form.'],
    [GaitProgramPrimaryFactor.HipExtensionTo, 'The largest contributor to your walking score is the amount of extension your hip goes through right before your foot comes off the ground. Too high or too low high extension may impact how your body generates or absorbs forces while walking. Exercises, drills, or cues for hip mobility/strength may help improve your walking form.'],
    [GaitProgramPrimaryFactor.AnkleSupination, 'The largest contributor to your walking score is the amount of supination your foot/ankle goes into right before your foot comes off the ground. Too high or low of supination can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your foot/ankle may help improve your walking form.'],
    [GaitProgramPrimaryFactor.KneeFlexionIcAsym, 'The largest contributor to your walking score is the side to side difference of the position of your knees when your foot hits the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PelvicRotationIcAsym, 'The largest contributor to your walking score is the side to side difference of the position of your pelvis when your foot hits the ground. Too high or too low of a rotation can impact how your body maintains stability. Exercises, drills, or cues for hip and lower back mobility/strength may help improve your walking form.'],
    [GaitProgramPrimaryFactor.PelvicDropMSAsym, 'The largest contributor to your walking score is the side to side difference of the amount your pelvis drops while your foot is on the ground. High amounts of pelvic drop may indicate hip weakness that can impact how your body maintains stability. Exercises, drills, or cues for hip mobility/strength may help improve your walking form.'],
    [GaitProgramPrimaryFactor.HipAddAsym, 'The largest contributor to your walking score is the side to side difference of the adduction of your hip while your foot is on the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your hip may help improve your walking form.'],
    [GaitProgramPrimaryFactor.KneeFlexionMsAsym, 'The largest contributor to your walking score is the side to side difference of the position of your knee while your foot is on the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your knee may help improve your walking form.'],
    [GaitProgramPrimaryFactor.HipFlexionTo, 'The largest contributor to your walking score is the side to side difference of the the amount of extension your hip goes through right before your foot comes off the ground. Too high or too low high extension may impact how your body generates or absorbs forces while walking. Exercises, drills, or cues for hip mobility/strength may help improve your walking form.'],
    [GaitProgramPrimaryFactor.AnkleFlexionTo, 'The largest contributor to your walking score is the side to side difference in the amount of plantarflexion your foot/ankle goes into right before your foot comes off the ground. Too high or low of plkantarflexion can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your foot/ankle may help improve your walking form.'],
    [GaitProgramPrimaryFactor.HipIr, 'The largest contributor to your walking score is the side to side difference in the rotation of your hip while your foot is on the ground. Too high or too low of an angle can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your hip may help improve your walking form.'],
    [GaitProgramPrimaryFactor.AnklePronation, 'The largest contributor to your walking score is the side to side difference in the movement of your foot/ankle into pronation while your foot is on the ground. Too high or too low pronation can impact how your body absorbs and generates the forces for walking. Exercises, drills, or cues to improve the mobility/strength of your foot/ankle may help improve your walking form.'],
  ]);

  public static PainTypeEnum = new Map<number, string>([
    [PainType.Rest, 'Rest'],
    [PainType.Activity, 'Activity'],
    [PainType.Both, 'Both'],
  ]);

  public static TwoDimensionalAssessmentResultEnum = new Map<number, string>([
    [TwoDimensionalAssessmentResult.NeedsAttention, 'Needs Attention'],
    [TwoDimensionalAssessmentResult.Satisfactory, 'Satisfactory'],
  ]);

  public static ClientDayEventTypeEnum = new Map<number, string>([
    [ClientDayEventType.Workout, 'Workout'],
    [ClientDayEventType.RestDay, 'Rest Day'],
    [ClientDayEventType.Event, 'Event'],
    [ClientDayEventType.Task, 'Task'],
    [ClientDayEventType.GarminSyncedWorkout, 'Garmin Synced Workout'],
    [ClientDayEventType.ManualWorkout, 'Manual Workout'],
    [ClientDayEventType.StravaSyncedWorkout, 'Strava Synced Workout'],
    [ClientDayEventType.QuickWorkout, 'Quick Workout'],
  ]);

  public static DayOfWeekFlagEnum = new Map<number, string>([
    [DayOfWeekFlag.Sunday, 'Sunday'],
    [DayOfWeekFlag.Monday, 'Monday'],
    [DayOfWeekFlag.Tuesday, 'Tuesday'],
    [DayOfWeekFlag.Wednesday, 'Wednesday'],
    [DayOfWeekFlag.Thursday, 'Thursday'],
    [DayOfWeekFlag.Friday, 'Friday'],
    [DayOfWeekFlag.Saturday, 'Saturday'],
  ]);

  public static RecurringEventFrequencyEnum = new Map<number, string>([
    [RecurringEventFrequency.Never, 'Never'],
    [RecurringEventFrequency.Daily, 'Daily'],
    [RecurringEventFrequency.Weekly, 'Weekly'],
  ]);

  public static WorkoutCategoryEnum = new Map<number, string>([
    [WorkoutCategory.Warmup, 'Warm Up'],
    [WorkoutCategory.Cardio, 'Cardio'],
    [WorkoutCategory.Mobility, 'Mobility'],
    [WorkoutCategory.Core, 'Core'],
    [WorkoutCategory.Strength, 'Strength'],
    [WorkoutCategory.Rehab, 'Rehab'],
  ]);

  public static AFHealthRiskCategoryEnum = new Map<number, string>([
    [AFHealthRiskCategory.LowRisk, 'Low Risk'],
    [AFHealthRiskCategory.ModerateRisk, 'Moderate Risk'],
    [AFHealthRiskCategory.HighRisk, 'High Risk'],
  ]);

  public static AFCompositeScoreCategoryEnum = new Map<number, string>([
    [AFCompositeScoreCategory.Unsatisfactory, 'Unsatisfactory'],
    [AFCompositeScoreCategory.Satisfactory, 'Satisfactory'],
    [AFCompositeScoreCategory.Excellent, 'Excellent'],
  ]);

  public static AFFitnessAssessmentCardioExerciseTypeEnum = new Map<number, string>([
    [AFFitnessAssessmentCardioExerciseType.Run, '1.5 Mile Run'],
    [AFFitnessAssessmentCardioExerciseType.HamrShuttle, 'HAMR Shuttle'],
  ]);

  public static AFFitnessAssessmentMuscular1ExerciseTypeEnum = new Map<number, string>([
    [AFFitnessAssessmentMuscular1ExerciseType.Pushup, 'Pushups'],
    [AFFitnessAssessmentMuscular1ExerciseType.HandReleasePushup, 'Hand-release Pushups'],
  ]);

  public static AFFitnessAssessmentMuscular2ExerciseTypeEnum = new Map<number, string>([
    [AFFitnessAssessmentMuscular2ExerciseType.Situp, 'Situps'],
    [AFFitnessAssessmentMuscular2ExerciseType.CrossLegReverseCrunch, 'Cross Leg Reverse Crunch'],
    [AFFitnessAssessmentMuscular2ExerciseType.ForearmPlank, 'Forearm Plank'],
  ]);

  public static OrganizationTypeEnum = new Map<number, string>([
    [OrganizationType.General, 'General'],
    [OrganizationType.HasUSAFFitnessAssessment, 'HasUSAFFitnessAssessment'],
  ]);

  public static NotificationTypeEnum = new Map<number, string>([
    [NotificationType.DailyWorkout, 'Daily Workout'],
    [NotificationType.ProgramAssigned, 'Program Assigned'],
    [NotificationType.WeeklyAthleteReport, 'Weekly Athlete Report'],
    [NotificationType.SyncedWorkoutRPE, 'Synced Workout RPE'],
    [NotificationType.WeeklyTrainingLoadTarget, 'Weekly Training Load Target'],
    [NotificationType.InAppMessage, 'In-App Message'],
  ]);

  public static TrainingLoadPeriodTypeEnum = new Map<number, string>([
    [TrainingLoadPeriodType.Maintenance, 'Maintenance'],
    [TrainingLoadPeriodType.Base, 'Base'],
    [TrainingLoadPeriodType.Build, 'Build'],
    [TrainingLoadPeriodType.Peak, 'Peak'],
    [TrainingLoadPeriodType.Rest, 'Rest'],
    [TrainingLoadPeriodType.Taper, 'Taper'],
    [TrainingLoadPeriodType.Race, 'Race'],
    [TrainingLoadPeriodType.Skip, 'Skip'],
  ]);

  public static VDOTPaceTypeEnum = new Map<number, string>([
    [VDOTPaceType.Easy, 'Easy'],
    [VDOTPaceType.Marathon, 'Marathon'],
    [VDOTPaceType.Threshold, 'Threshold'],
    [VDOTPaceType.Interval, 'Interval'],
    [VDOTPaceType.Repetition, 'Repetition'],
  ]);

  public static RaceDistanceTypeEnum = new Map<number, string>([
    [RaceDistanceType.FiveK, '5K'],
    [RaceDistanceType.TenK, '10K'],
    [RaceDistanceType.HalfMarathon, 'Half Marathon'],
    [RaceDistanceType.Marathon, 'Marathon'],
    [RaceDistanceType.Custom, 'Custom'],
  ]);

  public static CurrentMessageModeEnum = new Map<number, string>([
    [CurrentMessageMode.SpecificUser, 'SpecificUser'],
    [CurrentMessageMode.AllAthletes, 'AllAthletes'],
    [CurrentMessageMode.AllCoaches, 'AllCoaches'],
    [CurrentMessageMode.SpecificTeam, 'SpecificTeam'],
  ]);

  public static ActivityTypeEnum = new Map<number, string>([
    [ActivityType.Running, 'Running'],
    [ActivityType.Biking, 'Biking'],
    [ActivityType.Swimming, 'Swimming'],
    [ActivityType.Walking, 'Walking'],
    [ActivityType.StrengthTraining, 'Strength Training'],
    [ActivityType.Other, 'Other'],
  ]);

  public static CalendarTypeEnum = new Map<number, string>([
    [CalendarType.Client, 'Client'],
    [CalendarType.Team, 'Team'],
  ]);

  public static CalendarContextMenuOptionsEnum = new Map<number, string>([
    [CalendarContextMenuOptions.None, 'None'],
    [CalendarContextMenuOptions.View, 'View'],
    [CalendarContextMenuOptions.Edit, 'Edit'],
    [CalendarContextMenuOptions.Delete, 'Delete'],
    [CalendarContextMenuOptions.ToggleComplete, 'Toggle Complete'],
    [CalendarContextMenuOptions.Copy, 'Copy'],
  ]);

  public static TeamUserRoleEnum = new Map<number, string>([
    [TeamUserRole.None, 'None'],
    [TeamUserRole.Runner, 'Athlete'],
    [TeamUserRole.Coach, 'Coach'],
  ]);

  public static SurveyQuestionTypeEnum = new Map<number, string>([
    [SurveyQuestionType.OneAnswerOnly, 'OneAnswerOnly'],
    [SurveyQuestionType.MultipleAnswersOptional, 'MultipleAnswersOptional'],
    [SurveyQuestionType.MultipleAnswersRequired, 'MultipleAnswersRequired'],
  ]);

  public static ProgramCategoryEnum = new Map<number, string>([
    [ProgramCategory.Cardio, 'Cardio'],
    [ProgramCategory.Mobility, 'Mobility'],
    [ProgramCategory.Rehab, 'Rehab'],
    [ProgramCategory.Strength, 'Strength'],
  ]);

  public static MarketplaceStatusEnum = new Map<number, string>([
    [MarketplaceStatus.None, 'None'],
    [MarketplaceStatus.PendingStripeSetup, 'Pending Stripe Setup'],
    [MarketplaceStatus.Active, 'Active'],
  ]);

  public static MarketplaceCategoryDisplayTypeEnum = new Map<number, string>([
    [MarketplaceCategoryDisplayType.ByCoach, 'By Coach'],
    [MarketplaceCategoryDisplayType.ByKeyword, 'By Keyword'],
  ]);

  public static AthleteTypeEnum = new Map<number, string>([
    [AthleteType.Coached, 'Coached'],
    [AthleteType.Marketplace, 'Marketplace'],
  ]);

  public static GlobalMarketplaceExperienceLevelEnum = new Map<number, string>([
    [GlobalMarketplaceExperienceLevel.All, 'All'],
    [GlobalMarketplaceExperienceLevel.Beginner, 'Beginner'],
    [GlobalMarketplaceExperienceLevel.Intermediate, 'Intermediate'],
    [GlobalMarketplaceExperienceLevel.Advanced, 'Advanced'],
    [GlobalMarketplaceExperienceLevel.Elite, 'Elite'],
  ]);

  public static GlobalMarketplaceProgramTypeEnum = new Map<number, string>([
    [GlobalMarketplaceProgramType.FiveK, '5k'],
    [GlobalMarketplaceProgramType.TenK, '10k'],
    [GlobalMarketplaceProgramType.HalfMarathon, 'Half Marathon'],
    [GlobalMarketplaceProgramType.Marathon, 'Marathon'],
    [GlobalMarketplaceProgramType.Ultra, 'Ultra'],
    [GlobalMarketplaceProgramType.TrackLess800m, 'Track <800m'],
    [GlobalMarketplaceProgramType.TrackGreater800m, 'Track 800m+'],
    [GlobalMarketplaceProgramType.Triathlon, 'Triathlon'],
    [GlobalMarketplaceProgramType.BaseBuilding, 'Base Building'],
    [GlobalMarketplaceProgramType.RehabInjury, 'Rehab / Injury'],
    [GlobalMarketplaceProgramType.StrengthCore, 'Strength and Core'],
    [GlobalMarketplaceProgramType.OtherDistance, 'Other Distance'],
  ]);

  public static GarminPoolLengthUnitEnum = new Map<number, string>([
    [GarminPoolLengthUnit.METER, 'Meters'],
    [GarminPoolLengthUnit.YARD, 'Yards'],
  ]);

  public static WorkoutItemGarminRepeatTypeEnum = new Map<number, string>([
    [WorkoutItemGarminRepeatType.REPEAT_UNTIL_STEPS_CMPLT, 'Repeat Until Steps Complete'],
  ]);

  public static GarminWorkoutStepIntensityEnum = new Map<number, string>([
    [GarminWorkoutStepIntensity.WARMUP, 'Warm up'],
    [GarminWorkoutStepIntensity.ACTIVE, 'Active'],
    [GarminWorkoutStepIntensity.RECOVERY, 'Recovery'],
    [GarminWorkoutStepIntensity.REST, 'Rest'],
    [GarminWorkoutStepIntensity.COOLDOWN, 'Cool down'],
  ]);

  public static GarminWorkoutStepDurationTypeEnum = new Map<number, string>([
    [GarminWorkoutStepDurationType.TIME, 'Time'],
    [GarminWorkoutStepDurationType.DISTANCE, 'Distance'],
    [GarminWorkoutStepDurationType.OPEN, 'Lap Button Press'],
  ]);

  public static GarminWorkoutStepDurationValueTypeEnum = new Map<number, string>([
    [GarminWorkoutStepDurationValueType.MILE, 'Miles'],
    [GarminWorkoutStepDurationValueType.KILOMETER, 'KM'],
    [GarminWorkoutStepDurationValueType.METER, 'Meters'],
    [GarminWorkoutStepDurationValueType.YARD, 'Yards'],
  ]);

  public static GarminWorkoutStepTargetTypeEnum = new Map<number, string>([
    [GarminWorkoutStepTargetType.SPEED, 'Speed'],
    [GarminWorkoutStepTargetType.PACE, 'Pace'],
    [GarminWorkoutStepTargetType.HEART_RATE_ZONE, 'Heart Rate Zone'],
    [GarminWorkoutStepTargetType.HEART_RATE_CUSTOM, 'Custom Heart Rate'],
    [GarminWorkoutStepTargetType.POWER_ZONE, 'Power Zone'],
    [GarminWorkoutStepTargetType.POWER_CUSTOM, 'Custom Power'],
  ]);

  public static GarminWorkoutStepTargetValueTypeEnum = new Map<number, string>([
    [GarminWorkoutStepTargetValueType.MINS_PER_MILE, 'Min/Mile'],
    [GarminWorkoutStepTargetValueType.MINS_PER_KILOMETER, 'Min/KM'],
    [GarminWorkoutStepTargetValueType.MILES_PER_HOUR, 'MPH'],
    [GarminWorkoutStepTargetValueType.KILOMETERS_PER_HOUR, 'KPH'],
    [GarminWorkoutStepTargetValueType.MIN_PER_100_YARDS, 'Min/100y'],
    [GarminWorkoutStepTargetValueType.MIN_PER_100_METERS, 'Min/100m'],
  ]);

  public static GarminWorkoutStepStrokeTypeEnum = new Map<number, string>([
    [GarminWorkoutStepStrokeType.BACKSTROKE, 'Backstroke'],
    [GarminWorkoutStepStrokeType.BREASTSTROKE, 'Breaststroke'],
    [GarminWorkoutStepStrokeType.DRILL, 'Drill'],
    [GarminWorkoutStepStrokeType.BUTTERFLY, 'Butterfly'],
    [GarminWorkoutStepStrokeType.FREESTYLE, 'Freestyle'],
    [GarminWorkoutStepStrokeType.MIXED, 'Mixed'],
    [GarminWorkoutStepStrokeType.IM, 'Individual Medley'],
  ]);

  public static GarminWorkoutStepEquipmentTypeEnum = new Map<number, string>([
    [GarminWorkoutStepEquipmentType.NONE, 'None'],
    [GarminWorkoutStepEquipmentType.SWIM_FINS, 'Swim Fins'],
    [GarminWorkoutStepEquipmentType.SWIM_KICKBOARD, 'Swim Kickboard'],
    [GarminWorkoutStepEquipmentType.SWIM_PADDLES, 'Swim Paddles'],
    [GarminWorkoutStepEquipmentType.SWIM_PULL_BUOY, 'Swim Pull Buoy'],
    [GarminWorkoutStepEquipmentType.SWIM_SNORKEL, 'Swim Snorkel'],
  ]);

  public static MeasurementSystemEnum = new Map<number, string>([
    [MeasurementSystem.Imperial, 'Imperial'],
    [MeasurementSystem.Metric, 'Metric'],
  ]);

  public static ExerciseResistanceTypeEnum = new Map<number, string>([
    [ExerciseResistanceType.Resistance, 'Resistance'],
    [ExerciseResistanceType.Weight, 'Weight'],
    [ExerciseResistanceType.Hold, 'Hold'],
  ]);

  public static GaitCapabilityCategoryEnum = new Map<number, string>([
    [GaitCapabilityCategory.Uncategorized, 'Uncategorized'],
    [GaitCapabilityCategory.KneelingDorsiflexion, 'Kneeling Dorsiflexion'],
    [GaitCapabilityCategory.Thomas, 'Thomas'],
    [GaitCapabilityCategory.ASLR, 'ASLR'],
    [GaitCapabilityCategory.ToeTouch, 'Toe Touch'],
    [GaitCapabilityCategory.SitToStand, 'Sit To Stand '],
    [GaitCapabilityCategory.CalfRaise, 'Calf Raise'],
    [GaitCapabilityCategory.PaperGrip, 'Paper Grip'],
    [GaitCapabilityCategory.UHBE, 'UHBE'],
    [GaitCapabilityCategory.FourStageBalance, '4 Stage Balance'],
    [GaitCapabilityCategory.Hurdle, 'Hurdle'],
    [GaitCapabilityCategory.HalluxExtension, 'Hallux Extension'],
    [GaitCapabilityCategory.ToeSplay, 'Toe Splay'],
    [GaitCapabilityCategory.HalluxABD, 'Hallux ABD'],
    [GaitCapabilityCategory.Rotation, 'Rotation'],
  ]);

  public static WeightUOMEnum = new Map<number, string>([
    [WeightUOM.Pounds, 'lbs'],
    [WeightUOM.Kilograms, 'kgs'],
  ]);

  public static JournalTypeEnum = new Map<number, string>([
    [JournalType.General, 'General Journal'],
    [JournalType.Workout, 'Workout Journal'],
    [JournalType.DailyStatus, 'Daily Status'],
  ]);

  public static ComparisonDirectionEnumEnum = new Map<number, string>([
    [ComparisonDirectionEnum.Equal, 'Equal'],
    [ComparisonDirectionEnum.Up, 'Up'],
    [ComparisonDirectionEnum.Down, 'Down'],
  ]);

  public static ComparisonResultEnumEnum = new Map<number, string>([
    [ComparisonResultEnum.Equal, 'Equal'],
    [ComparisonResultEnum.Better, 'Better'],
    [ComparisonResultEnum.Worse, 'Worse'],
  ]);

  public static WalkingCategoryEnum = new Map<number, string>([
    [WalkingCategory.Uncategorized, 'Uncategorized'],
    [WalkingCategory.SpeedCadence, 'Speed / Cadence'],
    [WalkingCategory.Symmetry, 'Symmetry'],
    [WalkingCategory.Balance, 'Balance'],
    [WalkingCategory.FootAnkle, 'Foot / Ankle'],
    [WalkingCategory.Knee, 'Knee'],
    [WalkingCategory.Hip, 'Hip'],
    [WalkingCategory.Posture, 'Posture'],
  ]);

  public static RunDnaProductEnum = new Map<number, string>([
    [RunDnaProduct.Undefine, 'Undefine'],
    [RunDnaProduct.RunnerCount, 'RunnerCount'],
    [RunDnaProduct.Helix, 'Helix'],
  ]);

  public static FootStrikePatternEnum = new Map<number, string>([
    [FootStrikePattern.Undefined, 'Undefined'],
    [FootStrikePattern.Rearfoot, 'Rearfoot'],
    [FootStrikePattern.NonRearfoot, 'Non-rearfoot'],
  ]);

  public static RunningAnalysisReportScoreDescriptionEnum = new Map<number, string>([
    [RunningAnalysisReportScoreDescription.Green, 'Nice job! Your total running score is in the Green category, indicating that your score is within the healthy range. Individual scores in yellow or red may indicate areas to address to avoid future injury risk.'],
    [RunningAnalysisReportScoreDescription.Yellow, 'Your total running score is in the Yellow category, indicating minimal to moderate running gait defects. Individual scores in yellow or red indicate areas that may contribute to past, current, or future injuries and should be addressed.'],
    [RunningAnalysisReportScoreDescription.Orange, 'Your total running score is in the Orange category, indicating moderate to high running gait defects. Individual scores in yellow or red indicate areas that may contribute to past, current, or future injuries and should be addressed.'],
    [RunningAnalysisReportScoreDescription.Red, 'Your total running score is in the Red category, indicating significant running gait deficits. Individual scores in yellow or red indicate areas that may contribute to past, current, or future injuries and should be addressed.'],
  ]);

  public static SpeedUnitEnum = new Map<number, string>([
    [SpeedUnit.kmh, 'km/h'],
    [SpeedUnit.mph, 'mph'],
  ]);

  public static DistanceUnitEnum = new Map<number, string>([
    [DistanceUnit.Cm, 'Cm'],
    [DistanceUnit.Inches, 'Inches'],
  ]);

  public static RunningDirectionEnum = new Map<number, string>([
    [RunningDirection.Undefined, 'Undefined'],
    [RunningDirection.SideLeft, 'Left Side View'],
    [RunningDirection.SideRight, 'Right Side View'],
    [RunningDirection.Front, 'Front View'],
    [RunningDirection.Back, 'Back View'],
  ]);

  public static RunningCueEnum = new Map<number, string>([
    [RunningCue.None, ''],
    [RunningCue.Metronome, 'Use Metronome'],
    [RunningCue.FootOffGround, 'Foot Off Ground'],
    [RunningCue.LowBounce, 'Low Bounce'],
    [RunningCue.RunLong, 'run_long'],
    [RunningCue.RunUphill, 'un_uphill_leaning_from_the_ankles_not_the_waist'],
    [RunningCue.KneeDrive, 'Knee Drive'],
  ]);

  public static TwoDimensionalProfileTypeEnum = new Map<number, string>([
    [TwoDimensionalProfileType.FormOnly, 'FormOnly'],
    [TwoDimensionalProfileType.FormAndRunnerProfile, 'FormAndRunnerProfile'],
    [TwoDimensionalProfileType.Full, 'Full'],
  ]);

  public static YearsOfExperienceEnum = new Map<number, string>([
    [YearsOfExperience.Undefined, 'NA'],
    [YearsOfExperience.LessThanOne, '<1'],
    [YearsOfExperience.OneThree, '1-3'],
    [YearsOfExperience.ThreeSix, '3-6'],
    [YearsOfExperience.SixTen, '6-10'],
    [YearsOfExperience.TenPlus, '10+'],
  ]);

  public static RunnerSlowdownFactorEnum = new Map<number, string>([
    [RunnerSlowdownFactor.Undefined, 'NA'],
    [RunnerSlowdownFactor.AerobicLimitation, 'I can\'t catch my breath'],
    [RunnerSlowdownFactor.CardiovascularStrain, 'My heart is racing'],
    [RunnerSlowdownFactor.LegTurnoverLimitation, 'I try to run faster but can\'t seem to move any quicker'],
    [RunnerSlowdownFactor.EnduranceDecline, 'I start strong but can\'t hold my pace'],
    [RunnerSlowdownFactor.MuscularFatigue, 'My legs feel heavy or tired'],
    [RunnerSlowdownFactor.MentalFatigue, 'I lose focus or motivation'],
    [RunnerSlowdownFactor.PainDiscomfort, 'I slow down because of pain or discomfort'],
    [RunnerSlowdownFactor.InjuryConcern, 'I worry about getting injured if I push harder'],
  ]);

  public static RunnerMotivationEnum = new Map<number, string>([
    [RunnerMotivation.Undefined, 'NA'],
    [RunnerMotivation.HealthAndWellness, 'Health and Wellness'],
    [RunnerMotivation.Competition, 'Competition or training for a race'],
    [RunnerMotivation.Fun, 'Just for fun'],
    [RunnerMotivation.SocialConnection, 'Social connection'],
    [RunnerMotivation.CrossTraining, 'Training for another sport'],
  ]);

  public static TargetRaceTypeEnum = new Map<number, string>([
    [TargetRaceType.Undefined, 'NA'],
    [TargetRaceType.Other, 'Other'],
    [TargetRaceType.Mile, 'Mile'],
    [TargetRaceType.FiveK, '5K'],
    [TargetRaceType.TenK, '10K'],
    [TargetRaceType.FifteenK, '15K'],
    [TargetRaceType.TenMile, '10-Mile'],
    [TargetRaceType.HalfMarathon, 'Half Marathon'],
    [TargetRaceType.Marathon, 'Marathon'],
    [TargetRaceType.UltraMarathon, 'Ultra Marathon'],
    [TargetRaceType.TrailRace, 'Trail Races'],
    [TargetRaceType.Triathlon, 'Triathlon'],
  ]);

  public static RunningFormApproachEnum = new Map<number, string>([
    [RunningFormApproach.Undefined, 'NA'],
    [RunningFormApproach.DataDriven, 'I understand running form well, I\'m familiar with the terminology, and I enjoy analyzing data to improve performance'],
    [RunningFormApproach.Learning, 'I have limited familiarity with running form data, but I\'m interested in learning more'],
    [RunningFormApproach.PracticalImprovement, 'I\'m mainly interested in what I can do to run better, not in the technical details'],
    [RunningFormApproach.HealthFocused, 'I care most about staying healthy and preventing injuries, not about data or performance metrics'],
    [RunningFormApproach.SimpleGuidance, 'I just enjoy running and want simple, easy-to-follow guidance'],
  ]);

  public static InjurySiteEnum = new Map<number, string>([
    [InjurySite.Undefined, 'NA'],
    [InjurySite.Foot, 'Foot'],
    [InjurySite.Ankle, 'Ankle'],
    [InjurySite.Shin, 'Shin'],
    [InjurySite.Knee, 'Knee'],
    [InjurySite.FrontOfThigh, 'Front of thigh'],
    [InjurySite.BackOfThigh, 'Back of thigh'],
    [InjurySite.Hip, 'Hip'],
    [InjurySite.Groin, 'Groin'],
    [InjurySite.LowerBack, 'Lower back'],
    [InjurySite.Other, 'Other location'],
    [InjurySite.Calf, 'Calf'],
  ]);

  public static InjurySideEnum = new Map<number, string>([
    [InjurySide.Undefined, 'NA'],
    [InjurySide.Right, 'Right side'],
    [InjurySide.Left, 'Left side'],
    [InjurySide.Both, 'Both sides'],
  ]);

  public static GenderPublicEnum = new Map<number, string>([
    [GenderPublic.Undefined, 'NA'],
    [GenderPublic.Male, 'Male'],
    [GenderPublic.Female, 'Female'],
    [GenderPublic.Other, 'Other'],
  ]);

  public static InjuryImpactEnum = new Map<number, string>([
    [InjuryImpact.Undefined, 'NA'],
    [InjuryImpact.NoImpact, 'It doesn\'t impact my running'],
    [InjuryImpact.ReducedDistance, 'I\'ve reduced the amount of miles I\'m running per week, but I\'m still running'],
    [InjuryImpact.WeekOrMoreOff, 'I\'ve taken a week or more off without running'],
  ]);

  public static InjuryImpactPastEnum = new Map<number, string>([
    [InjuryImpactPast.Undefined, 'NA'],
    [InjuryImpactPast.NoImpact, 'It didn’t impact my running'],
    [InjuryImpactPast.ReducedDistance, 'I had to reduce the amount of miles I was running per week, but was still running'],
    [InjuryImpactPast.WeekOrMoreOff, 'I took a week or more off without running'],
  ]);

  public static InjuryAgoEnum = new Map<number, string>([
    [InjuryAgo.Undefined, 'NA'],
    [InjuryAgo.ZeroToThreeMonths, '0-3 months ago'],
    [InjuryAgo.ThreeToSixMonths, '3-6 months ago'],
    [InjuryAgo.SixToTwelveMonths, '6-12 months ago'],
    [InjuryAgo.Recurring, 'Recurring'],
  ]);

  public static MovementCapabilityEnum = new Map<number, string>([
    [MovementCapability.Able, 'Able'],
    [MovementCapability.Unable, 'Unable'],
    [MovementCapability.Pain, 'Pain'],
  ]);

  public static RunningAnalysisProgramPrimaryFactorEnum = new Map<number, string>([
    [RunningAnalysisProgramPrimaryFactor.Uncategorized, 'Uncategorized'],
    [RunningAnalysisProgramPrimaryFactor.Cadence, 'The largest contributor to your running score is cadence. Cadence is the number of steps per minute. There is no ideal cadence, but slower cadences have been linked to certain injuries.'],
    [RunningAnalysisProgramPrimaryFactor.VerticalOscillation, 'The largest contributor to your running score is vertical oscillation. Vertical oscillation is the amount of motion spent going up and down. Focusing your energy on running forward rather than up and down helps with injuries and performance.'],
    [RunningAnalysisProgramPrimaryFactor.GroundContactTime, 'The largest contributor to your running score is ground contact time. Ground contact time is the time spent with your foot on the ground. Minimizing the time spent on the ground helps with decreasing injuries and improving performance.'],
    [RunningAnalysisProgramPrimaryFactor.GroundContactTimeAsymmetry, 'The largest contributor to your running score is ground contact time asymmetry. Ground contact time is the time spent with your foot on the ground. Asymmetrical ground contact time may cause imbalance in your stride and is a risk factor for injuries and loss of performance.'],
    [RunningAnalysisProgramPrimaryFactor.FrontSideStance, 'The largest contributor to your running score is front side stance. Front side stance is the percentage of stance phase that happens in front of your center of mass. Higher front side stance may indicate increased stress on the body and elevated injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.FrontSideStanceAsymmetry, 'The largest contributor to your running score is front side stance asymmetry. Front side stance is the percentage of stance phase that happens in front of your center of mass. Asymmetrical front side stance may cause imbalance in your stride and is a risk factor for injuries and loss of performance.'],
    [RunningAnalysisProgramPrimaryFactor.DutyFactor, 'The largest contributor to your running score is duty factor. Duty factor is the percentage of time spent on the ground (stance) versus the percentage of time spent in the air (swing). High duty factor may lead to overuse and increased injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.DutyFactorAsymmetry, 'The largest contributor to your running score is duty factor asymmetry. Duty factor is the percentage of time spent on the ground (stance) versus the percentage of time spent in the air (swing). Asymmetrical duty factors may create uneven loading on the body and is a risk factor for injuries and loss of performance.'],
    [RunningAnalysisProgramPrimaryFactor.TibialInclinationIC, 'The largest contributor to your running score is tibial inclination at initial contact. Tibial inclination is the angle of your shin bone relative to the ground. High tibial inclination at initial contact may increase the stress experienced by the body and increase injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.TibialInclinationICAsymmetry, 'The largest contributor to your running score is tibial inclination asymmetry at initial contact. Tibial inclination is the angle of your shin bone relative to the ground. Tibial inclination asymmetry at initial contact may cause uneven distribution of stress through the lower limbs and increase injury risk. '],
    [RunningAnalysisProgramPrimaryFactor.FootInclinationIC, 'The largest contributor to your running score is foot inclination at initial contact. Foot inclination is the angle of your foot relative to the ground. High foot inclination at initial contact may cause uneven distribution of stress through the lower limbs and increase injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.FootInclinationICAsymmetry, 'The largest contributor to your running score is foot inclination asymmetry at initial contact. Foot inclination is the angle of your foot relative to the ground. High foot inclination asymmetry at initial contact may cause uneven distribution of stress through the lower limbs and increase injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.StrikeCOM, 'The largest contributor to your running score is strike from center of mass (COM). Strike from COM is the distance from your center of mass to where your foot hits the ground. High strike from COM may increase the stress experienced by the body and the risk of injury.'],
    [RunningAnalysisProgramPrimaryFactor.StrikeCOMAsymmetry, 'The largest contributor to your running score is strike from center of mass (COM) asymmetry. Strike from COM is the distance from your center of mass to where your foot hits the ground. Asymmetrical strike from COM may cause imbalance in your stride and is a risk factor for injuries and loss of performance.'],
    [RunningAnalysisProgramPrimaryFactor.PeakKneeFlexion, 'The largest contributor to your running score is peak knee flexion. Peak knee flexion is the highest degree of bending that your knee experiences during stance phase. Peak knee flexion during stance is a measure of how much your body is sinking into the ground and reflects the amount of stress the body is experiencing.'],
    [RunningAnalysisProgramPrimaryFactor.PeakKneeFlexionAsymmetry, 'The largest contributor to your running score is peak knee flexion asymmetry. Peak knee flexion is the highest degree of bending that your knee experiences during stance phase. Peak knee flexion asymmetry during stance may cause imbalance in your stride and is a risk factor for injuries and loss of performance.'],
    [RunningAnalysisProgramPrimaryFactor.PeakHipADD, 'The largest contributor to your running score is peak hip adduction. Peak hip adduction is the highest degree of hip motion toward the midline of the body. Peak hip adduction during stance is an important part of absorbing forces, but excessive motion can put increased strain on the body and increase injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.PeakHipADDAsymmetry, 'The largest contributor to your running score is peak hip adduction asymmetry. Peak hip adduction is the highest degree of hip motion toward the midline of the body. Peak hip adduction asymmetry during stance may cause uneven absorption of stress through the lower limbs and increase injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.PeakHipIR, 'The largest contributor to your running score is peak hip internal rotation (IR). Hip IR is the rotation of the hip inwards toward the midline of the body. Peak hip IR during stance is an important part of absorbing forces, but excessive motion can put increased strain on the body and increase injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.PeakHipIRAsymmetry, 'The largest contributor to your running score is peak hip internal rotation (IR) asymmetry. Hip IR is the rotation of the hip inwards toward the midline of the body. Peak hip IR asymmetry during stance may cause uneven absorption of stress through the lower limbs and increase injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.ForwardLeanAngleMS, 'The largest contributor to your running score is forward lean angle at mid-stance. Forward lean angle is a measure of how far forward or backwards you lean during running. Low forward lean angle at mid-stance may increase the stress on the body, increase injury risk, and lower performance.'],
    [RunningAnalysisProgramPrimaryFactor.HipExtensionTS, 'The largest contributor to your running score is hip extension at terminal stance. Hip extension measures the straightening of the hip at the end of stance phase. Excessive or insufficient hip extension at terminal stance can place additional stress on the lower back, hips, and knees, increasing the risk of injury.'],
    [RunningAnalysisProgramPrimaryFactor.HipExtensionTSAsymmetry, 'The largest contributor to your running score is hip extension at terminal stance asymmetry. Hip extension measures the straightening of the hip at the end of stance phase. Hip extension asymmetry at terminal stance may cause uneven distribution of stress through the lower limbs and increase injury risk.'],
    [RunningAnalysisProgramPrimaryFactor.PeakContralateralPelvicDrop, 'The largest contributor to your running score is peak contralateral pelvic drop. Contralateral pelvic drop is the downward movement of the pelvis on the opposite side of the stance leg. Excessive peak contralateral pelvic drop is associated with excessive hip, knee, and ankle collapse and can increase injury risk. '],
    [RunningAnalysisProgramPrimaryFactor.PeakContralateralPelvicDropAsymmetry, 'The largest contributor to your running score is peak contralateral pelvic drop asymmetry. Contralateral pelvic drop is the downward movement of the pelvis on the opposite side of the stance leg. Peak contralateral pelvic drop asymmetry may cause imbalance in your stride and is a risk factor for injuries and loss of performance.'],
    [RunningAnalysisProgramPrimaryFactor.PeakHipFlexion, 'The largest contributor to your running score is peak hip flexion. Peak hip flexion is the highest degree of bending that your hip experiences during swing phase. Peak hip flexion is related to the rate at which the foot accelerates toward the ground at IC and may impact the absorption of forces and risk of injury.'],
    [RunningAnalysisProgramPrimaryFactor.PeakHipFlexionAsymmetry, 'The largest contributor to your running score is peak hip flexion asymmetry. Peak hip flexion is the highest degree of bending that your hip experiences during swing phase. Peak hip flexion asymmetry may cause uneven absorption of stress through the lower limbs at initial contact and increase injury risk'],
    [RunningAnalysisProgramPrimaryFactor.PeakAnklePronation, 'The largest contributor to your running score is peak ankle pronation. Ankle pronation is the inward rolling motion of the foot. Ankle pronation plays a role in absorbing forces, but excessive motion can increase the risk of injury.'],
    [RunningAnalysisProgramPrimaryFactor.PeakAnklePronationAsymmetry, 'The largest contributor to your running score is peak ankle pronation asymmetry. Ankle pronation is the inward rolling motion of the foot. Ankle pronation asymmetry may cause uneven absorption of stress through the lower limbs and increase injury risk.'],
  ]);

}
